import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { Breadcrumbs } from "src/components/Breadcrumb/Breadcrumbs.tsx";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext.tsx";
import { ScoreDetailTabs, Tabs } from "./InnerTabs/ScoreDetailTabs";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { HeaderOptions, ScoreCardHeader } from "@foodpilot/foods";

type ScoreDetailProps = {
    selectedTab: Tabs;
};
export const ScoreDetail = (props: ScoreDetailProps) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const { score, selectedVariations, scoresParams, scoreWithVariations, drilldownState, tabConfig } =
        useScoreDetailContext();

    const scoreWithVariationsHeaderOptions = scoreWithVariations?.map((scoreWithVariation): HeaderOptions => {
        return {
            id: scoreWithVariation.variationId ?? 0,
            label: scoreWithVariation.label,
            group: scoreWithVariation.group,
            onClick: () => {
                scoresParams?.state.selectVariation(scoreWithVariation.scoreId, scoreWithVariation.variationId);
                selectedVariations?.state.selectVariation(scoreWithVariation.scoreId, scoreWithVariation.variationId);
            },
        };
    });

    const selectedVariationId = scoresParams?.query.scores?.variations?.[score.id] ?? 0;

    useEffect(() => {
        if (props.selectedTab === null) {
            const entrypointUrl = tabConfig.distribution.link(score.id);
            navigate(entrypointUrl, { replace: true });
        }
    }, []);

    return (
        <Stack>
            <Stack gap={1} mb={3}>
                {!isMobile && (
                    <ScoreCardHeader
                        variant="primary"
                        selectedItemId={selectedVariationId}
                        options={scoreWithVariationsHeaderOptions ?? []}
                        orientation="horizontal"
                        extraStyle={{
                            noExtraSpacing: true,
                        }}
                    />
                )}
                <Box display="flex">
                    <Breadcrumbs items={drilldownState.breadcrumbs} />
                </Box>
            </Stack>
            <ScoreDetailTabs selectedTab={props.selectedTab} />
        </Stack>
    );
};
